import { accordion } from './components/accordion.js';
import { alignFull } from './components/alignFull';
import { buttons } from './components/buttons';
import { clock } from './components/clock.js';
import { coverPoster } from './components/coverPoster';
import { desktopMenu } from './components/desktopMenu';
import { featuredPosts } from './components/featuredPosts.js';
import { filtersAndPages } from './components/filtersAndPages.js';
import { gforms } from './components/gforms';
import { imageCarousel } from './components/imageCarousel.js';
import { landing } from './components/landing.js';
import { loadMore } from './components/loadMore';
import { logoMarquee } from './components/logoMarquee.js';
import { mobileMenu } from './components/mobileMenu';
import { newHires } from './components/newHires.js';
import { responsiveEmbeds } from './components/responsiveEmbeds';
import { scrollCards } from './components/scrollCards.js';
import { shareButtons } from './components/shareButtons.js';
import { search, closeSearch } from './components/search';
import { team } from './components/team.js';
import { timeline } from './components/timeline.js';
import { videoButton } from './components/videoButton';
import { videoLightbox } from './components/videoLightbox';
import { gridQuoteReveal } from './components/gridQuoteReveal';
import { numberCardsCarousel } from './components/numberCardsCarousel';
import { investments } from './components/investments.js';
import { heroAnimation } from './components/heroAnimation.js';
import { cookieYes } from './components/cookieYes.js';
import { groupSlider } from './components/groupSlider.js';

global.$ = global.jQuery;

$(() => {
  // console.log('is working?');
  // global
  mobileMenu();
  desktopMenu();
  alignFull();
  buttons();
  search();
  gforms();
  heroAnimation();
  groupSlider();
  cookieYes();
  // components & blocks
  accordion();
  clock();

  coverPoster();
  featuredPosts();
  imageCarousel();
  landing();
  loadMore();
  logoMarquee();
  newHires();
  responsiveEmbeds();
  scrollCards();
  shareButtons();
  timeline();
  team();
  videoButton();
  videoLightbox();
  gridQuoteReveal();
  numberCardsCarousel();

  // ACF Block filters & pagination
  filtersAndPages({ selector: '.wp-block-news', resetSelects: true });
  filtersAndPages({ selector: '.wp-block-podcasts-list' });
  // filtersAndPages({ selector: '.wp-block-team' });
  // investments
  filtersAndPages({ selector: '.wp-block-investments' });
  investments();

  // close open things on escape
  window.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeSearch();
    }
  });
});
